export const SPORTS_LOAD = 'sports/on_load';
export const sportsLoad = (platformType) => ({
  type: SPORTS_LOAD,
  platformType: platformType
});

export const SPORTS_LOAD_SUCCESS = 'sports/on_load_success';
export const sportsLoadSuccess = (data) => ({
  type: SPORTS_LOAD_SUCCESS,
  payload: data
});